import React from 'react'

export const CrossModal = () => {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M19.001 5.5L5.00098 19.5M5.00098 5.5L19.001 19.5" stroke="#141B34" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}
